import { section } from '@/neon';
import { emit, hydrate } from '@/neon/events';
import { fetchCart } from '@/neon/cart.js';
import Delegate from 'ftdomdelegate';

const selectors = {
  cartItems: '[data-cart-items]',
  cartInfo: '[data-cart-info]',
  quantityInput: '[data-quantity-input]',
  quantityButton: '[data-quantity-button]',
  quantityWrapper: '[data-quantity-wrapper]',
  loading: '[data-loading]'
};


section('cart', {
  onLoad() {
    this.dynamicCartEnabled = this.container.dataset.dynamicCartEnabled;
    this.cartItems = this.container.querySelector(selectors.cartItems);
    this.cartInfo = this.container.querySelector(selectors.cartInfo);
    this.loading = this.container.querySelector(selectors.loading);

    this.delegate = new Delegate(this.container);

    this.delegate.on('click', selectors.quantityButton, this._handleQuantityButton);

    
    this.delegate.on('change', selectors.quantityInput, evt => {
      this._handleQuantitychange(evt);
    });
  },

  _handleQuantitychange(evt) {
    const key = evt.target.dataset.lineItemKey;
    const quantity = parseInt(evt.target.value);
    const inventoryQuantity = parseInt(evt.target.dataset.inventoryQuantity);
    const inventoryManagement = evt.target.dataset.inventoryManagement;

    if (this.dynamicCartEnabled === 'true') {
      this._updateLineItemQuantity(key, quantity).then(() => {
        this._renderView().then(() => {
          if (inventoryManagement === 'shopify' && quantity > inventoryQuantity) {
            const quantityInput = this.container.querySelector(`${selectors.quantityInput}[data-line-item-key='${key}']`);
            
            quantityInput.setCustomValidity(`${theme.strings.cart.general.quantity_error_updated} ${quantity} → ${inventoryQuantity}`);
            quantityInput.reportValidity();
          }
        });
      });
    } else {
      if (inventoryManagement === 'shopify' && quantity > inventoryQuantity) {
        const quantityInput = this.container.querySelector(`${selectors.quantityInput}[data-line-item-key='${key}']`);
        quantityInput.setCustomValidity(theme.strings.cart.general.quantity_error);
        quantityInput.reportValidity();
      }
    }
  },

  _handleQuantityButton(evt) {
    const { quantityButton } = evt.target.closest(selectors.quantityButton).dataset;
    const quantityWrapper = evt.target.closest(selectors.quantityWrapper);
    const quantityInput = quantityWrapper.querySelector(selectors.quantityInput);
    const currentValue = parseInt(quantityInput.value);
    let newValue = currentValue;

    if (quantityButton === 'subtract') {
      newValue = currentValue - 1;
    } else if (quantityButton === 'add') {
      newValue = currentValue + 1;
    }

    quantityInput.value = newValue;
    quantityInput.dispatchEvent(new Event('change', { "bubbles": true }));
  },

  async _updateLineItemQuantity(id, quantity) {
    this.loading.classList.add('is-active');
    return fetch(`${theme.routes.cart.change}.js`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id, quantity }),
    })
      .then(res => res.json());
  },

  async _renderView() {
    const url = `${window.location.pathname}?section_id=${this.container.dataset.sectionId}`;

    return fetch(url, { credentials: 'include' })
      .then(res => res.text())
      .then(res => {
        const doc = new window.DOMParser().parseFromString(res, 'text/html');
        const items = doc.querySelector(selectors.cartItems).innerHTML;
        this.cartItems.innerHTML = items;
        const info = doc.querySelector(selectors.cartInfo).innerHTML;
        this.cartInfo.innerHTML = info;

        return fetchCart().then(cart => {
          hydrate({ cart: cart });
          emit('cart:updated', { cartOpen: true, cart: cart });
          this.loading.classList.remove('is-active');
  
          return { cart };
        });
      });
  },

  onUnload() {
    this.delegate.off();
  }
});
